export function GetURLFromId(id: string) {
    return `https://youtube.swarmtunes.com/audio/${id}?redirect=best`
}